if (!customElements.get('pdp-pack-selector')) {
  const COD_BUTTON_SELECTOR = '#rsi-button-hook button, #rsi-button-hook [role="button"]';
  const WAIT_FOR_BUTTON_MS = 6000;

  class PdpPackSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onPackChange.bind(this));
    }

    onPackChange(event) {
      const radio = event.target.closest('.pdp-packs__radio');
      if (!radio) return;

      const quantity = radio.value;
      const section = this.closest('.pdp-packs');
      if (!section) return;

      const quantityInput = section.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = quantity;
      }

      this.openCodForm(section);
    }

    openCodForm(section) {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._timeout) {
        clearTimeout(this._timeout);
        this._timeout = null;
      }

      const existingButton = section.querySelector(COD_BUTTON_SELECTOR);
      if (existingButton) {
        existingButton.click();
        return;
      }

      const hook = section.querySelector('#rsi-button-hook') || section.querySelector('.pdp-packs__buy');
      if (!hook) return;

      this._observer = new MutationObserver(() => {
        const button = section.querySelector(COD_BUTTON_SELECTOR);
        if (button) {
          this._observer.disconnect();
          this._observer = null;
          clearTimeout(this._timeout);
          this._timeout = null;
          button.click();
        }
      });
      this._observer.observe(hook, { childList: true, subtree: true });

      this._timeout = setTimeout(() => {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }, WAIT_FOR_BUTTON_MS);
    }
  }

  customElements.define('pdp-pack-selector', PdpPackSelector);
}
